import React from 'react';
import Select, { Option } from "rc-select";
import BankAccountCon from "./../../../Components/Common/BankAccount";

import translate from "./../../../lib/translate/TranslateJs";


function BankAccount(props) {
    return (
        <BankAccountCon
            {...props}
            // 充值金额提示信息标签
            Select={(propCon) => {
                return <Select
                    showSearch={false}
                    value={propCon.currValue}
                    optionLabelProp="children"
                    onChange={propCon.onSelectChange}
                >
                    {propCon.bankAccounts.map((v, i) => (
                        <Option key={i} value={v[propCon.keyVal]}>{v[propCon.keyName]}</Option>
                    ))}
                </Select>
            }}
        />
    );
}


export default BankAccount;

